import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { moveProductsToTrash } from './productsSlice';
const AllProducts = () => {
    const dispatch = useAppDispatch();
    const { allProducts, isProductStatLoading, isProductsMovingToTrash } = useAppSelector((state) => state.products);
    const acceptTrash = () => {
        dispatch(moveProductsToTrash());
    };
    const confirmTrash = () => {
        confirmDialog({
            message: 'Do you want to trash all the products?',
            header: 'Trash Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: acceptTrash
        });
    };
    const renderButtons = () => {
        if (allProducts) {
            let trashButtonLabel = (isProductsMovingToTrash) ? 'Moving to trash...' : 'Move To Trash';
            let productText = allProducts > 1 ? 'products' : 'product';
            return _jsxs("p", { children: [_jsxs("p", { children: [allProducts, " ", productText, " found"] }), _jsx("button", Object.assign({ className: "button-primary dap-button-primary", style: { marginLeft: '10px' }, onClick: confirmTrash, disabled: isProductsMovingToTrash }, { children: trashButtonLabel }))] });
        }
        else if (!isProductStatLoading) {
            return _jsx("p", { children: "No products found" });
        }
        return null;
    };
    const renderLoader = () => {
        if (isProductStatLoading) {
            return _jsx("p", { children: "Loading..." });
        }
        return null;
    };
    return _jsxs(_Fragment, { children: [_jsx(ConfirmDialog, { draggable: false }), renderLoader(), renderButtons()] });
};
export default AllProducts;
